<template>
    <card class="card-plain">
        <form>
            <div v-if="customer" class="card-body row pt-0">
                <div class="col-lg-12">
                    <div class="row">
                        <div class="col-lg-6">
                            <fg-input name="contactEmail"
                                      type="email"
                                      :label="$t('Main Contact Email')"
                                      autocomplete="off"
                                      :error="getError('contactEmail')"
                                      v-model="customer.contactEmail"
                                      v-validate="validations.contactEmail"
                                      :placeholder="$t('Main Contact Email')">
                            </fg-input>
                            <fg-input name="name"
                                      :label="$t('Name')"
                                      autocomplete="off"
                                      required
                                      :error="getError('name')"
                                      v-model="customer.name"
                                      v-validate="validations.name"
                                      :placeholder="$t('Name')">
                            </fg-input>
                        </div>
                        <div class="col-lg-6">
                          <fg-input :label="$t('Timezone')">
                                <el-select
                                  size="medium"
                                  class="select-primary"
                                  v-model="customer.settings.timezone" >
                                  <el-option
                                    v-for="timezone in timezones"
                                    :key="timezone"
                                    :label="timezone"
                                    :value="timezone">
                                  </el-option>
                                </el-select>
                            </fg-input>
                            <fg-input :label="$t('Date format')">
                                <el-select
                                        size="medium"
                                        class="select-primary"
                                        v-model="customer.settings.dateFormat" >
                                    <el-option
                                            v-for="dateFormat in dateFormats"
                                            :key="dateFormat.value"
                                            :label="$t(dateFormat.label)"
                                            :value="dateFormat.value">
                                    </el-option>
                                </el-select>
                            </fg-input>
                            <fg-input :label="$t('Dashboard Questionnaire')"
                                      name="questionnaires"
                                      :value="questionnaire ? questionnaire._id : null">
                                <input-picker v-model="questionnaire" data-type="questionnaire" @input="setQuestionnaire" />
                            </fg-input>
                        </div>
                        <div class="col-12">
                            <hr>
                            <upload v-model="customer.icon" :image-url="imageUrl" :change="fileChange" :disabledComponent="true"/>
                            <div class="row" v-if="false">
                                <div class="col-6">
                                    <label>{{ $t('Primary Color') }}</label>
                                    <el-color-picker class="color-picker" :predefine="predefineColors"
                                                     v-model="customer.colors.primary"
                                                     disabled/>
                                </div>
                                <div class="col-6">
                                    <label>{{ $t('Secondary Color') }}</label>
                                    <el-color-picker class="color-picker" :predefine="predefineColors"
                                                     v-model="customer.colors.secondary"
                                                     disabled/>
                                </div>
                            </div>
                        </div>
<!--                        <div v-if="customer.settings.contract.userLimit && customer.settings.contract.packageType" class="col-lg-4 ml-auto mr-auto">-->
<!--                            <el-card shadow="always" class="mt-4">-->
<!--                                <legend class="pr-2 pl-2 license-information-label">License information</legend>-->
<!--                                <h6 class="mt-2 p-4 license-information-text">{{`${$t('User limit')}: ${customer.settings.contract.userLimit}`}}</h6>-->
<!--                                <h6 class="p-4 license-information-text">{{`${$t('Package')}: ${customer.settings.contract.packageType}`}}</h6>-->
<!--                            </el-card>-->
<!--                            <br />-->

                    </div>
                </div>
            </div>
            <div class="card-footer text-right actions">
                <p-button round native-type="submit" type="primary" class="btn btn-fill btn-wd btn-one-size-dropdown" :disabled="loading" @click.prevent="save">
                    {{$t('Save')}}
                </p-button>
            </div>
        </form>
    </card>
</template>

<script>
  import { Button, Input, ColorPicker, Col, Row, Card, Select, Option } from 'element-ui'
  import Upload from '../../Components/BasicUpload'
  import { CustomerRecord } from '../../../../store/models/Customer'
  import moment from 'moment-timezone'
  import InputPicker from '../../Components/InputPicker'
  import QuestionnaireModel from "../../../../store/models/Questionnaire"
  import set from 'lodash/set'

  export default {
    name: 'Settings',
    components: {
      Upload,
      [ColorPicker.name]: ColorPicker,
      [Input.name]: Input,
      [Col.name]: Col,
      [Row.name]: Row,
      [Card.name]: Card,
      [Button.name]: Button,
      [Select.name]: Select,
      [Option.name]: Option,
      InputPicker
    },
    data () {
      return {
        customer: null,
        questionnaire: null,
        imageUrl: null,
        loading: false,
        dateFormats: [{value: 'DD. MMM', label: 'Date'}, {value: '[CW] WW', label: 'Week'}],
        timezones: moment.tz.names(),
        predefineColors: ['#ff4500', '#ff8c00', '#ffd700', '#90ee90', '#00ced1', '#1e90ff', '#c71585', '#c7158577'],
        validations: {
          name: {
            required: true,
            min: 5
          },
          contactEmail: {
            email: true
          }
        }
      }
    },
    mounted () {
      this.init()
    },
    methods: {
      async init () {
        await this.fetch()
      },
      async fetch () {
        try {
          this.loading = true
          const result = await CustomerRecord.api().get(`/customer`, { save: false })
          this.customer = new CustomerRecord(result.response.data)

          if (this.customer.settings.dashboard && this.customer.settings.dashboard.questionnaire) {
            const questionnaireResult = await QuestionnaireModel.api().get(`/questionnaire/${this.customer.settings.dashboard.questionnaire}`, { save: false })
            this.questionnaire = new QuestionnaireModel(questionnaireResult.response.data)
          } else {
            this.questionnaire = new QuestionnaireModel()
          }
        } catch (e) { console.log('e', e)} finally {
          this.loading = false
        }
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      fileChange (url) {
        this.imageUrl = url
      },
      async save () {
        const isValid = await this.$validator.validateAll()
        if (!isValid) {
          return
        }

        const { name, contactEmail, colors, settings } = this.customer
        const data = { name, contactEmail, colors, settings: { timezone: settings.timezone, dateFormat: settings.dateFormat, dashboard: settings.dashboard } }

        if (this.imageUrl) {
          data.icon = this.imageUrl
        } else {
          data.icon = this.customer.icon
        }

        try {
          this.loading = true

          const result = await CustomerRecord.api().put(`/customer`, data, { save: false })
          this.customer = new CustomerRecord(result.response.data)

          this.$notify({ message: this.$t('Successfully saved.'), type: 'success' })
          this.imageUrl = null
        } catch (e) {
          this.$notify({ message: e.message, type: 'danger' })
        } finally {
          this.loading = false
        }
      },
      setQuestionnaire (value) {
        set(this.customer.settings, 'dashboard.questionnaire', value._id)
      }
    }
  }
</script>

<style lang="scss">
    .el-table {
        &__fixed-right {
            background-color: #FFFFFF;
        }
    }

    .color-picker {
        width: 100%;
    }

    .license-information-label {
        position: absolute;
        width: auto;
        top: 5px;
        background-color: #ffffff;
    }

    .license-information-text {
        text-transform: capitalize;
        font-weight: normal;
    }

    @media (max-width: 590px) {
      .btn-one-size-dropdown {
          width: 100%;
          padding-left: 0px;
          padding-right: 0px;
          padding-right: 10px !important;
      }

      .card-footer {
        padding-left: 5px;
      }
    }
</style>
